import { makeStyles } from 'tss-react/mui';

// Constants
import { colors } from '../../../styles/palette';

export const useStyles = makeStyles()((theme, { isPlacedOrder } = {}) => ({
  layout: {
    paddingTop: theme.spacing(3),
    paddingBottom: theme.spacing(13),
    minHeight: 'calc(100vh - 240px)',
    [theme.breakpoints.down('lg')]: {
      display: 'flex',
      flexDirection: 'column',
      minHeight: isPlacedOrder ? 'calc(100vh - 55px)' : 'calc(100vh - 110px)',
      paddingBottom: theme.spacing(3.75),
    },
    [theme.breakpoints.down('md')]: {
      paddingTop: isPlacedOrder ? theme.spacing(2.5) : theme.spacing(2.25),
      paddingBottom: theme.spacing(3.25),
    },
    '& #next-button': {
      [theme.breakpoints.down('md')]: {
        width: isPlacedOrder && '296px !important',
      },
    },
  },
  apiError: {
    color: colors.gilead.primary1,
    fontSize: 14,
  },
}));
